//region AmmocanOptions
export const AmmocanOptions = {
  sizes: ["Ammocan"],
  colors: [],
  locks: [],
};
//endregion

//region AmmocanOptions
export const FridgeOptions = {
  sizes: ["Fridge"],
  colors: [],
  locks: [],
};
//endregion

//region CenturionOptions
export const CenturionOptions = {
  sizes: ["centurion12", "centurion18", "centurion24", "centurion32"],
  colors: [],
  locks: ["securamtoplit", "mechanicallock"],
};
//endregion

//region ClassicPlusOptions
export const ClassicPlusOptions = {
  sizes: ["classicplus25", "classicplus40", "classicplus50"],
  colors: [
    {
      hardware: "blackchromehardware",
      outer: "burgundymarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "whitemarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "champagnemarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "graymarble",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "greenmarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "bronzegloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "champagnegloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "forestmistgloss",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "blackcherry",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "mirrorblack",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "whitegloss",
      interior: "beigevelour",
    },
    {
      hardware: "chromehardware",
      outer: "bluegloss",
      interior: "silvervelour",
    },
    {
      hardware: "chromehardware",
      outer: "mirrorblack",
      interior: "silvervelour",
    },
    {
      hardware: "brasshardware",
      outer: "burgundymarble",
      interior: "beigevelour",
    },
    {
      hardware: "brasshardware",
      outer: "greenmarble",
      interior: "beigevelour",
    },
    {
      hardware: "brasshardware",
      outer: "burgundygloss",
      interior: "beigevelour",
    },
    {
      hardware: "brasshardware",
      outer: "mirrorblack",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "graycharcoalfeatherededge",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "champagnefeatherededge",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "emeraldgreenfeatherededge",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "burgundymetallicfeatherededge",
      interior: "beigevelour",
    },
  ],
  locks: ["securamprologic", "mechanicallock"],
  woodshelf: ["pindotvelour", "woodgrainvinyl"],
};
//endregion

//region ClassicSelectOptions
export const ClassicSelectOptions = {
  sizes: ["classicselect60"],
  colors: [
    {
      hardware: "blackchromehardware",
      outer: "burgundymarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "whitemarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "champagnemarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "graymarble",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "greenmarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "bronzegloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "greengloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "forestmistgloss",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "burgundygloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "blackcherry",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "mirrorblack",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "whitegloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "champagnegloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "graygloss",
      interior: "silvervelour",
    },
    {
      hardware: "chromehardware",
      outer: "bluegloss",
      interior: "silvervelour",
    },
    {
      hardware: "chromehardware",
      outer: "mirrorblack",
      interior: "silvervelour",
    },
    {
      hardware: "brasshardware",
      outer: "burgundymarble",
      interior: "beigevelour",
    },
    {
      hardware: "brasshardware",
      outer: "greenmarble",
      interior: "beigevelour",
    },
    {
      hardware: "brasshardware",
      outer: "greengloss",
      interior: "beigevelour",
    },
    {
      hardware: "brasshardware",
      outer: "burgundygloss",
      interior: "beigevelour",
    },
    {
      hardware: "brasshardware",
      outer: "mirrorblack",
      interior: "beigevelour",
    },
  ],
  locks: ["securamprologic", "mechanicallock"],
};
//endregion

//region ColonialOptions
export const ColonialOptions = {
  sizes: ["colonial23", "colonial30", "colonial50", "colonial50extreme"],
  colors: [
    {
      hardware: "blackchromehardware",
      outer: "bronzetextured",
      interior: "camelfabric",
    },
    {
      hardware: "blackchromehardware",
      outer: "graymarble",
      interior: "grayfabric",
    },
    {
      hardware: "blackchromehardware",
      outer: "whitegloss",
      interior: "camelfabric",
    },
    {
      hardware: "blackchromehardware",
      outer: "graygloss",
      interior: "grayfabric",
    },
    {
      hardware: "chromehardware",
      outer: "texturedblack",
      interior: "grayfabric",
    },
    {
      hardware: "chromehardware",
      outer: "texturedgranite",
      interior: "grayfabric",
    },
    {
      hardware: "chromehardware",
      outer: "blackgloss",
      interior: "grayfabric",
    },
    {
      hardware: "brasshardware",
      outer: "whitegloss",
      interior: "camelfabric",
    },
  ],
  locks: ["securambacklit", "mechanicallock"],
};
//endregion

export const ColonialNewOptions = {
  sizes: [
    "colonial23standard",
    "colonial23proflex",
    "colonial30standard",
    "colonial30proflex",
    "colonial50standard",
    "colonial50proflex",
    "colonial50extreme",
  ],
  colors: [
    {
      hardware: "blackchromehardware",
      outer: "bronzetextured",
      interior: "camelfabric",
    },
    {
      hardware: "blackchromehardware",
      outer: "graymarble",
      interior: "grayfabric",
    },
    {
      hardware: "blackchromehardware",
      outer: "whitegloss",
      interior: "camelfabric",
    },
    {
      hardware: "blackchromehardware",
      outer: "graygloss",
      interior: "grayfabric",
    },
    {
      hardware: "chromehardware",
      outer: "texturedblack",
      interior: "grayfabric",
    },
    {
      hardware: "chromehardware",
      outer: "texturedgranite",
      interior: "grayfabric",
    },
    {
      hardware: "chromehardware",
      outer: "blackgloss",
      interior: "grayfabric",
    },
    {
      hardware: "brasshardware",
      outer: "whitegloss",
      interior: "camelfabric",
    },
  ],
  locks: ["securambacklit", "mechanicallock"],
};

//region FatboyOptions
export const FatboyOptions = {
  sizes: [
    // "fatboyjrextreme",
    "fatboyjr",
    "fatboyjrxl",
    // "fatboyextreme",
    "fatboy",
  ],
  colors: [
    {
      hardware: "blackchromehardware",
      outer: "texturedblack",
      interior: "grayfabric",
    },
    {
      hardware: "blackchromehardware",
      outer: "bronzetextured",
      interior: "camelfabric",
    },
    {
      hardware: "blackchromehardware",
      outer: "graymarble",
      interior: "grayfabric",
    },
    {
      hardware: "chromehardware",
      outer: "texturedblack",
      interior: "grayfabric",
    },
    {
      hardware: "chromehardware",
      outer: "texturedgranite",
      interior: "grayfabric",
    },
  ],
  locks: ["mechanicallock", "securamprologic", "securambacklit"],
};
//endregion

//region FranklinOptions
export const FranklinOptions = {
  sizes: ["franklin23", "franklin40", "franklin50"],
  colors: [
    {
      hardware: "blackchromehardware",
      outer: "bronzetextured",
      interior: "camelfabric",
    },
    {
      hardware: "blackchromehardware",
      outer: "graymarble",
      interior: "grayfabric",
    },
    {
      hardware: "blackchromehardware",
      outer: "whitegloss",
      interior: "camelfabric",
    },
    {
      hardware: "blackchromehardware",
      outer: "graygloss",
      interior: "grayfabric",
    },
    {
      hardware: "chromehardware",
      outer: "texturedblack",
      interior: "grayfabric",
    },
    {
      hardware: "chromehardware",
      outer: "texturedgranite",
      interior: "grayfabric",
    },
    {
      hardware: "chromehardware",
      outer: "blackgloss",
      interior: "grayfabric",
    },
    {
      hardware: "brasshardware",
      outer: "whitegloss",
      interior: "camelfabric",
    },
  ],
  locks: ["mechanicallock", "securamprologic"],
};
//endregion

//region FranklinnOptions
export const FranklinnOptions = {
  sizes: ["franklin29", "franklin40", "franklin50"],
  colors: [
    {
      hardware: "blackchromehardwaree",
      outer: "bronzetextured",
      interior: "camelfauxleather",
    },
    {
      hardware: "blackchromehardware",
      outer: "graymarble",
      interior: "grayfauxleather",
    },
    {
      hardware: "blackchromehardware",
      outer: "whitegloss",
      interior: "camelfauxleather",
    },
    {
      hardware: "blackchromehardware",
      outer: "graygloss",
      interior: "grayfauxleather",
    },
    {
      hardware: "chromehardware",
      outer: "texturedblack",
      interior: "grayfauxleather",
    },
    {
      hardware: "chromehardware",
      outer: "texturedgranite",
      interior: "grayfauxleather",
    },
    {
      hardware: "chromehardware",
      outer: "blackgloss",
      interior: "grayfauxleather",
    },
    {
      hardware: "brasshardware",
      outer: "whitegloss",
      interior: "camelfauxleather",
    },
    {
      hardware: "blackchromehardware",
      outer: "graymarble",
      interior: "camel",
    },
  ],
  locks: ["mechanicallock", "securamdirectdrive"],
};
//endregion

//region FranklinnOptions
export const FranklinnnOptions = {
  sizes: ["franklin29", "franklin40", "franklin50"],
  colors: [
    {
      hardware: "blackchromehardware",
      outer: "bronzetextured",
      interior: "camelfauxleather",
    },
    {
      hardware: "blackchromehardware",
      outer: "graymarble",
      interior: "grayfauxleather",
    },
    {
      hardware: "blackchromehardware",
      outer: "whitegloss",
      interior: "camelfauxleather",
    },
    {
      hardware: "blackchromehardware",
      outer: "graygloss",
      interior: "grayfauxleather",
    },
    {
      hardware: "chromehardware",
      outer: "texturedblack",
      interior: "grayfauxleather",
    },
    {
      hardware: "chromehardware",
      outer: "texturedgranite",
      interior: "grayfauxleather",
    },
    {
      hardware: "chromehardware",
      outer: "blackgloss",
      interior: "grayfauxleather",
    },
    {
      hardware: "brasshardware",
      outer: "whitegloss",
      interior: "camelfauxleather",
    },
    {
      hardware: "blackchromehardware",
      outer: "graymarble",
      interior: "camel",
    },
  ],
  locks: ["mechanicallock", "securamdirectdrive"],
};
//endregion

//region FreedomOptions
export const FreedomOptions = {
  sizes: ["freedom30", "freedom36", "freedom48"],
  colors: [
    {
      hardware: "blackchromehardware",
      outer: "bronzetextured",
      interior: "camelfabric",
    },
    {
      hardware: "blackchromehardware",
      outer: "graymarble",
      interior: "grayfabric",
    },
    {
      hardware: "blackchromehardware",
      outer: "whitegloss",
      interior: "camelfabric",
    },
    {
      hardware: "blackchromehardware",
      outer: "graygloss",
      interior: "grayfabric",
    },
    {
      hardware: "chromehardware",
      outer: "texturedblack",
      interior: "grayfabric",
    },
    {
      hardware: "chromehardware",
      outer: "texturedgranite",
      interior: "grayfabric",
    },
    {
      hardware: "chromehardware",
      outer: "blackgloss",
      interior: "grayfabric",
    },
    {
      hardware: "brasshardware",
      outer: "whitegloss",
      interior: "camelfabric",
    },
  ],
  locks: ["mechanicallock", "securamtoplit"],
};
//endregion

//region HomesafeOptions
export const HomesafeOptions = {
  sizes: ["libertyhome8", "libertyhome12"],
  colors: [],
  locks: [],
};
//endregion
//region HomesafeOptionsse
export const HomesafeSeOptions = {
  sizes: ["se"],
  colors: [
    {
      hardware: "blackchromehardware",
      outer: "texturedblack",
      interior: "grayfabric",
    },
    {
      hardware: "blackchromehardware",
      outer: "graymarble",
      interior: "grayfabric",
    },
  ],
  locks: [],
};
//endregion
//region Collector
export const CollectorOptions = {
  sizes: ["collector","collectort"],
  colors: [
    {
      hardware: "chromehardware",
      outer: "texturedblack",
      interior: "grayfabric",
    },
    {
      hardware: "blackchromehardware",
      outer: "graymarble",
      interior: "grayfabric",
    },
  ],
  locks: ["securamprologic", "mechanicallock"],
};
//endregion

//region LincolnOptions
export const LincolnOptions = {
  sizes: ["lincoln25", "lincoln40", "lincoln50"],
  colors: [
    {
      hardware: "blackchromehardware",
      outer: "burgundymarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "champagnegloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "forestmistgloss",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "burgundygloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "blackcherry",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "greengloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "mirrorblack",
      interior: "silvervelour",
    },

    {
      hardware: "blackchromehardware",
      outer: "whitegloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "graygloss",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "whitemarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "graymarble",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "greenmarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "champagnemarble",
      interior: "beigevelour",
    },
    {
      hardware: "chromehardware",
      outer: "mirrorblack",
      interior: "silvervelour",
    },
    {
      hardware: "chromehardware",
      outer: "bluegloss",
      interior: "silvervelour",
    },
    {
      hardware: "brasshardware",
      outer: "burgundymarble",
      interior: "beigevelour",
    },
    {
      hardware: "brasshardware",
      outer: "burgundygloss",
      interior: "beigevelour",
    },
    {
      hardware: "brasshardware",
      outer: "greengloss",
      interior: "beigevelour",
    },
    {
      hardware: "brasshardware",
      outer: "greenmarble",
      interior: "beigevelour",
    },
    {
      hardware: "brasshardware",
      outer: "mirrorblack",
      interior: "beigevelour",
    },
  ],
  locks: ["mechanicallock", "securamprologic"],
};
//endregion

//region NationalMagnumOptions
export const NationalMagnumOptions = {
  sizes: ["nationalmagnum25", "nationalmagnum40", "nationalmagnum50"],
  colors: [
    {
      hardware: "blackchromehardware",
      outer: "burgundymarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "whitemarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "champagnemarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "graymarble",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "greenmarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "bronzegloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "forestmistgloss",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "blackcherry",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "mirrorblack",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "whitegloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "graycharcoalfeatherededge",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "champagnefeatherededge",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "emeraldgreenfeatherededge",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "burgundymetallicfeatherededge",
      interior: "beigevelour",
    },
    {
      hardware: "chromehardware",
      outer: "bluegloss",
      interior: "silvervelour",
    },
    {
      hardware: "chromehardware",
      outer: "mirrorblack",
      interior: "silvervelour",
    },
    {
      hardware: "brasshardware",
      outer: "burgundymarble",
      interior: "beigevelour",
    },
    {
      hardware: "brasshardware",
      outer: "burgundygloss",
      interior: "beigevelour",
    },
    {
      hardware: "brasshardware",
      outer: "mirrorblack",
      interior: "beigevelour",
    },
    {
      hardware: "brasshardware",
      outer: "emeraldgreen",
      interior: "beigevelour",
    },
  ],
  locks: ["mechanicallock", "securamprologic"],
  woodshelf: ["pindotvelour", "woodgrainvinyl"],
};
//endregion

//region PremiumHomesafesOptions
export const PremiumSafesOptions = {
  sizes: ["premiumhome8", "premiumhome12", "premiumhome17"],
  colors: [
    {
      hardware: "blackchromehardware",
      outer: "burgundymarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "bronzegloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "champagnegloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "forestmistgloss",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "burgundygloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "blackcherry",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "greengloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "mirrorblack",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "whitegloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "graygloss",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "whitemarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "champagnemarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "graymarble",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "greenmarble",
      interior: "beigevelour",
    },
    {
      hardware: "chromehardware",
      outer: "mirrorblack",
      interior: "silvervelour",
    },
    {
      hardware: "chromehardware",
      outer: "bluegloss",
      interior: "silvervelour",
    },
    {
      hardware: "brasshardware",
      outer: "burgundygloss",
      interior: "beigevelour",
    },
    {
      hardware: "brasshardware",
      outer: "greengloss",
      interior: "beigevelour",
    },
    {
      hardware: "brasshardware",
      outer: "greenmarble",
      interior: "beigevelour",
    },
  ],
  locks: [],
};
//endregion

//region PresidentialOptions
export const PresidentialOptions = {
  sizes: ["presidential25", "presidential40", "presidential50"],
  colors: [
    {
      hardware: "blackchromehardware",
      outer: "burgundymarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "whitemarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "champagnemarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "graymarble",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "greenmarble",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "mirrorblack",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "bronzegloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "champagnegloss",
      interior: "beigevelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "forestmistgloss",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "blackcherry",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "graycharcoal",
      interior: "silvervelour",
    },
    {
      hardware: "blackchromehardware",
      outer: "whitegloss",
      interior: "beigevelour",
    },
    {
      hardware: "chromehardware",
      outer: "bluegloss",
      interior: "silvervelour",
    },
    {
      hardware: "chromehardware",
      outer: "mirrorblack",
      interior: "silvervelour",
    },
    {
      hardware: "goldhardware",
      outer: "burgundymarble",
      interior: "beigevelour",
    },
    {
      hardware: "goldhardware",
      outer: "emeraldgreen",
      interior: "beigevelour",
    },
    {
      hardware: "goldhardware",
      outer: "burgundygloss",
      interior: "beigevelour",
    },
    {
      hardware: "goldhardware",
      outer: "mirrorblack",
      interior: "beigevelour",
    },
  ],
  locks: ["mechanicallock", "securamprologic"],
  woodshelf: ["pindotvelour", "woodgrainvinyl"],
};
//endregion

//region TacticalOptions
export const TacticalOptions = {
  sizes: ["tactical24"],
  colors: [],
  locks: [],
};
//endregion

//region UsaOptions
export const UsaOptions = {
  sizes: ["usa30", "usa36", "usa48", "usa50"],
  colors: [{}],
  locks: ["mechanicallock", "securamtoplit"],
};
//endregion

//region VaultdoorOptions
export const VaultOptions = {
  sizes: ["vaultdoorbeast", "vaultdoorblockade"],
  colors: [
    {
      hardware: "blackchromehardware",
      outer: "bronzegloss",
      interior: "none",
    },
    {
      hardware: "blackchromehardware",
      outer: "champagnegloss",
      interior: "none",
    },
    {
      hardware: "blackchromehardware",
      outer: "forestmistgloss",
      interior: "none",
    },
    {
      hardware: "blackchromehardware",
      outer: "graycharcoal",
      interior: "none",
    },
    {
      hardware: "blackchromehardware",
      outer: "blackcherry",
      interior: "none",
    },
    {
      hardware: "blackchromehardware",
      outer: "mirrorblack",
      interior: "none",
    },
    {
      hardware: "blackchromehardware",
      outer: "whitegloss",
      interior: "none",
    },
    {
      hardware: "blackchromehardware",
      outer: "graymarble",
      interior: "none",
    },
    {
      hardware: "chromehardware",
      outer: "texturedblack",
      interior: "none",
    },
    {
      hardware: "chromehardware",
      outer: "mirrorblack",
      interior: "none",
    },
    {
      hardware: "chromehardware",
      outer: "bluegloss",
      interior: "none",
    },
    {
      hardware: "brasshardware",
      outer: "mirrorblack",
      interior: "none",
    },
    {
      hardware: "brasshardware",
      outer: "burgundygloss",
      interior: "none",
    },
    {
      hardware: "brasshardware",
      outer: "emeraldgreen",
      interior: "none",
    },
  ],
  locks: ["mechanicallock", "securamprologic", "securamtoplit"],
  hinge: ["left", "right"],
  swing: ["out", "in"],
};

//endregion
//region AmmocanOptions
export const TestOptions = {
  sizes: ["Ammocan"],
  colors: [],
  locks: [],
};
//endregion

//region for colors
export const Colors = [
  //black chrome
  {
    outer: "whitemarble",
    interior: "beigevelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "burgundymarble",
    interior: "beigevelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "forestmistgloss",
    interior: "silvervelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "blackcherry",
    interior: "silvervelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "mirrorblack",
    interior: "silvervelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "whitegloss",
    interior: "beigevelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "graycharcoalfeatherededge",
    interior: "silvervelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "emeraldgreenfeatherededge",
    interior: "beigevelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "greengloss",
    interior: "beigevelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "graymarble",
    interior: "grayfabric",
    hardware: "blackchromehardware",
  },
  {
    outer: "graygloss",
    interior: "grayfabric",
    hardware: "blackchromehardware",
  },
  {
    outer: "texturedblack",
    interior: "grayfabric",
    hardware: "blackchromehardware",
  },
  {
    outer: "bronzetextured",
    interior: "camelfauxleather",
    hardware: "blackchromehardware",
  },
  {
    outer: "graymarble",
    interior: "grayfauxleather",
    hardware: "blackchromehardware",
  },
  {
    outer: "graygloss",
    interior: "grayfauxleather",
    hardware: "blackchromehardware",
  },
  {
    outer: "texturedblack",
    interior: "none",
    hardware: "blackchromehardware",
  },
  {
    outer: "champagnegloss",
    interior: "none",
    hardware: "blackchromehardware",
  },
  {
    outer: "forestmistgloss",
    interior: "none",
    hardware: "blackchromehardware",
  },
  {
    outer: "texturedwhite",
    interior: "grayfabric",
    hardware: "blackchromehardware",
  },
  {
    outer: "azuresky",
    interior: "beigevelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "icywhite",
    interior: "grayfabric",
    hardware: "blackchromehardware",
  },
  {
    outer: "frontiersage",
    interior: "grayfabric",
    hardware: "blackchromehardware",
  },
  {
    outer: "canvasbeige",
    interior: "grayfabric",
    hardware: "blackchromehardware",
  },
  {
    outer: "champagnemarble",
    interior: "beigevelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "graymarble",
    interior: "silvervelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "greenmarble",
    interior: "beigevelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "bronzegloss",
    interior: "beigevelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "champagnegloss",
    interior: "beigevelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "champagnefeatherededge",
    interior: "beigevelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "burgundygloss",
    interior: "beigevelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "graygloss",
    interior: "silvervelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "bronzetextured",
    interior: "camelfabric",
    hardware: "blackchromehardware",
  },
  {
    outer: "whitegloss",
    interior: "camelfabric",
    hardware: "blackchromehardware",
  },
  {
    outer: "whitegloss",
    interior: "camelfauxleather",
    hardware: "blackchromehardware",
  },
  {
    outer: "bronzegloss",
    interior: "none",
    hardware: "blackchromehardware",
  },
  {
    outer: "graycharcoal",
    interior: "none",
    hardware: "blackchromehardware",
  },
  {
    outer: "blackcherry",
    interior: "none",
    hardware: "blackchromehardware",
  },
  {
    outer: "mirrorblack",
    interior: "none",
    hardware: "blackchromehardware",
  },
  {
    outer: "whitegloss",
    interior: "none",
    hardware: "blackchromehardware",
  },
  {
    outer: "graymarble",
    interior: "none",
    hardware: "blackchromehardware",
  },
  {
    outer: "graycharcoal",
    interior: "silvervelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "burgundymetallicfeatherededge",
    interior: "beigevelour",
    hardware: "blackchromehardware",
  },
  {
    outer: "whitegloss",
    interior: "grayfabric",
    hardware: "blackchromehardware",
  },
  //black hardware
  {
    outer: "texturedblack",
    interior: "grayfabric",
    hardware: "blackhardware",
  },
  //chrome hardware
  {
    outer: "texturedblack",
    interior: "grayfabric",
    hardware: "chromehardware",
  },
  {
    outer: "graymarble",
    interior: "grayfabric",
    hardware: "chromehardware",
  },
  {
    outer: "texturedgranite",
    interior: "grayfabric",
    hardware: "chromehardware",
  },
  {
    outer: "blackgloss",
    interior: "grayfabric",
    hardware: "chromehardware",
  },
  {
    outer: "texturedblack",
    interior: "grayfauxleather",
    hardware: "chromehardware",
  },
  {
    outer: "texturedgranite",
    interior: "grayfauxleather",
    hardware: "chromehardware",
  },
  {
    outer: "blackgloss",
    interior: "grayfauxleather",
    hardware: "chromehardware",
  },
  {
    outer: "mirrorblack",
    interior: "silvervelour",
    hardware: "chromehardware",
  },
  {
    outer: "bluegloss",
    interior: "silvervelour",
    hardware: "chromehardware",
  },
  {
    outer: "texturedblack",
    interior: "none",
    hardware: "chromehardware",
  },
  {
    outer: "mirrorblack",
    interior: "none",
    hardware: "chromehardware",
  },
  {
    outer: "bluegloss",
    interior: "none",
    hardware: "chromehardware",
  },
  {
    outer: "texturedwhite",
    interior: "grayfabric",
    hardware: "chromehardware",
  },
  //brasshardware
  {
    outer: "burgundymarble",
    interior: "beigevelour",
    hardware: "brasshardware",
  },
  {
    outer: "greenmarble",
    interior: "beigevelour",
    hardware: "brasshardware",
  },
  {
    outer: "burgundygloss",
    interior: "beigevelour",
    hardware: "brasshardware",
  },
  {
    outer: "mirrorblack",
    interior: "beigevelour",
    hardware: "brasshardware",
  },
  {
    outer: "greengloss",
    interior: "beigevelour",
    hardware: "brasshardware",
  },
  {
    outer: "whitegloss",
    interior: "camelfabric",
    hardware: "brasshardware",
  },
  {
    outer: "whitegloss",
    interior: "camelfauxleather",
    hardware: "brasshardware",
  },
  {
    outer: "emeraldgreen",
    interior: "beigevelour",
    hardware: "brasshardware",
  },
  {
    outer: "mirrorblack",
    interior: "none",
    hardware: "brasshardware",
  },
  {
    outer: "burgundygloss",
    interior: "none",
    hardware: "brasshardware",
  },
  {
    outer: "emeraldgreen",
    interior: "none",
    hardware: "brasshardware",
  },
  //gold hardware
  {
    outer: "burgundymarble",
    interior: "beigevelour",
    hardware: "goldhardware",
  },
  {
    outer: "emeraldgreen",
    interior: "beigevelour",
    hardware: "goldhardware",
  },
  {
    outer: "mirrorblack",
    interior: "beigevelour",
    hardware: "goldhardware",
  },
  {
    outer: "burgundygloss",
    interior: "beigevelour",
    hardware: "goldhardware",
  },
];
//endregion for colors

export const Locks = [
  "keylock",
  "mechanicallock",
  "securamtoplit",
  "securamprologic",
  "securambacklit",
  "securamdirectdrive",
];
